module.exports = __webpack_public_path__ + "static/img/slider-4.c162a78.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/images/slider-4.jpeg
// module id = Dn0E
// module chunks = 1